import PropTypes from 'prop-types';
import React from 'react'

import { requestPasswordResetLink } from '~/actions/sessions'

export default class extends React.Component {
    static propTypes = {
		session: PropTypes.object,
		history: PropTypes.object.isRequired
	};

    state = {
        sentLink: false
    };

    requestLink = (e) => {

		e.preventDefault();

		let email = this.refs.email.value;
		if( !email ) return;

		this.props.dispatch( requestPasswordResetLink(email) )

		this.setState({
			sentLink: true
		})

	};

    render() {

		return (

			<div className="slide-transition">
				<fieldset>
					<div className="slide-holder">
						<img src="/img/logo.png" className="mbot40 pleft50 pright50 img-responsive" alt=""/>
						<div id="reset-slide" className="slide-wrapper">
							<header className="bg-deep-main ptop20 pbot20">
								<h4 className="text-dark-gray text-center mtop0 mbot0">Request a Password Reset Link</h4>
							</header>
							<div className="inner no-footer">

								<div className="bg-light-main bg-slightly-transparent transparent back">
									<form onSubmit={this.requestLink}>
										<div>
											<div className="reset-email">

												<div className="input">
													<i className="icon-envelope"></i>
													<input type="text" name="email" ref="email" placeholder="Email" className="form-control" />
													<div className="clearfix"></div>
												</div>

											</div>
											<div className="clearix"></div>
											<footer className="bg-deep-main text-center text-white">
												{ !this.state.sentLink
													? <button type="submit" className="p20 btn btn-none btn-block">
														Send Me a Link <i className="icon-arrow-right"></i>
													</button>
													: <div className="text-center ptop20 pbot20 text-pale-main">{
														this.props.session.fetching.passwordReset
															? 'Sending reset link...'
															: 'Reset link sent!'
													}</div>
												}
											</footer>
										</div>
									</form>
								</div>

							</div>
						</div>
					</div>
				</fieldset>
			</div>

		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/PasswordRequest/index.jsx